import React from "react";
import WebLayout from "../../../layout/WebLayout";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import { RootState } from "../../../stores";
import OrderAction from "../../../stores/actions/OrderAction";
import { Link, useParams } from "react-router-dom";
import CancelOrderButton from "../../../components/CancelOrderButton";
import { toast } from "react-toastify";

function MyOrdersList() {
  const routeParams = useParams();
  const myOrderStatus = routeParams.myOrderStatus;
  let status = "";
  let name = "";

  if (myOrderStatus === "pending") {
    status = "PENDING";
  } else if (myOrderStatus === "placed") {
    status = "PLACED";
  } else if (myOrderStatus === "dispatch") {
    status = "DISPATCH";
  } else if (myOrderStatus === "delivered") {
    status = "DELIVERED";
  } else if (myOrderStatus === "cancelled") {
    status = "CANCELLED";
  }

  const dispatch = useDispatch<any>();
  const { profileDetails } = useSelector((state: RootState) => state.auth);
  const { orderList, currentPage, lastPage, totalData, from, to } = useSelector(
    (state: RootState) => state.order
  );
  const [search, setSearch] = useState<any>();
  const [limit, setLimit] = useState<any>(10);
  const [page, setPage] = useState<number>(1);

  const maxPagesToShow = 5; // Maximum number of page links to show
  const pagination = [];

  const startPage = Math.max(currentPage - Math.floor(maxPagesToShow / 2), 1);
  const endPage = Math.min(startPage + maxPagesToShow - 1, lastPage);

  for (let i = startPage; i <= endPage; i++) {
    pagination.push(i);
  }

  const getOrderList = useCallback(async () => {
    await dispatch(
      OrderAction.getMyOrders({
        limit: limit,
        search: search,
        page: page,
        myOrderStatus: status,
      })
    );
  }, [dispatch, search, limit, page, myOrderStatus]);

  useEffect(() => {
    getOrderList();
  }, [getOrderList, search, limit, page, myOrderStatus]);

  const designStatus = (orderStatus: string) => {
    if (orderStatus === "PENDING") {
      return <span className="badge bg-label-warning me-1">{orderStatus}</span>;
    } else if (orderStatus === "PLACED") {
      return <span className="badge bg-label-info me-1">{orderStatus}</span>;
    } else if (orderStatus === "DISPATCH") {
      return (
        <span className="badge bg-label-secondary me-1">{orderStatus}</span>
      );
    } else if (orderStatus === "SHIPPED") {
      return <span className="badge bg-label-primary me-1">{orderStatus}</span>;
    } else if (orderStatus === "DELIVERED") {
      return <span className="badge bg-label-success me-1">{orderStatus}</span>;
    } else {
      return <span className="badge bg-label-danger me-1">{orderStatus}</span>;
    }
  };

  if (myOrderStatus === "pending") {
    name = "Order Placed";
  } else if (myOrderStatus === "placed") {
    name = "Order Dispatched";
  } else if (myOrderStatus === "dispatch") {
    name = "Order Received";
  } else if (myOrderStatus === "delivered") {
    name = "Delivered Orders";
  } else if (myOrderStatus === "cancelled") {
    name = "Cancelled Orders";
  }

  const onSubmit = async (id: number) => {
    if (
      window.confirm(`Order Received by ${profileDetails.name_of_entity} ?`)
    ) {
      try {
        await dispatch(
          OrderAction.myOrderReceived({
            id,
          })
        );
      } catch (e: any) {
        toast.error(e.message);
      }
    }
  };

  return (
    <WebLayout pageName={"MyOrdersList"}>
      <div className="content-wrapper">
        <div className="container-fluid flex-grow-1 container-p-y">
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center pb-2">
              <h4 className="card-title">{name}</h4>
            </div>
            <div
              className="row g-3 px-4 mb-2 d-flex
              justify-content-between
              align-items-end">
              <div className="col-md-3">
                <label className="mb-2">Show Entries</label>
                <select
                  className="form-select"
                  onChange={(e) => setLimit(e.target.value)}>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </div>
              <div className="col-md-3">
                <div className="input-group input-group-merge">
                  <span className="input-group-text" id="basic-addon-search31">
                    <i className="bx bx-search"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search..."
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="table-responsive text-nowrap">
              <table className="table text-center table-bordered">
                <thead>
                  <tr>
                    <th>SN.</th>
                    <th>Order Id</th>
                    <th>Price</th>
                    <th>Quantity</th>
                    <th>Order Status</th>
                    <th>Payment Status</th>
                    {myOrderStatus === "pending" ? (
                      ""
                    ) : (
                      <>
                        <th>Reason</th>
                        <th>Action</th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {orderList?.length > 0 ? (
                    orderList.map((orderDataList: any, index: number) => (
                      <tr key={orderDataList.id}>
                        <td>{from + index}</td>
                        <td>#{orderDataList.order_generate_id}</td>
                        <td>Rs. {orderDataList.totalPrice}</td>
                        <td>{orderDataList.totalQty}</td>
                        <td>{designStatus(orderDataList.order_status)}</td>

                        <td>
                          {orderDataList.payment_status === "VERIFY" ? (
                            <span className="badge bg-label-success mb-2">
                              {orderDataList.payment_status}
                            </span>
                          ) : (
                            <span className="badge bg-label-danger mb-2">
                              {orderDataList.payment_status}
                            </span>
                          )}
                        </td>

                        {myOrderStatus === "pending" ? (
                          ""
                        ) : (
                          <>
                            {" "}
                            {orderDataList.payment_status === "DECLINED" ? (
                              <td>{orderDataList.payment_reason}</td>
                            ) : (
                              "N/A"
                            )}
                            <td>
                              <Link
                                to={`/buyer-invoice/${orderDataList.id}`}
                                className={"btn btn-primary btn-sm"}>
                                Invoice
                              </Link>
                            </td>
                          </>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={7}>No matching records found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {orderList?.length > 0 ? (
              <div className="demo-inline-spacing px-4 m-auto">
                <h6>
                  Showing {from} to {to} of {totalData} entries
                </h6>
                <nav aria-label="Page navigation">
                  <ul className="pagination pagination-round pagination-primary">
                    <li className="page-item first" onClick={() => setPage(1)}>
                      <a className="page-link" href="javascript:void(0);">
                        <i className="tf-icon bx bx-chevrons-left"></i>
                      </a>
                    </li>
                    <li
                      className={`page-item prev ${
                        page === 1 ? "disabled" : ""
                      }`}
                      onClick={() =>
                        page === 1 ? "" : setPage(currentPage - 1)
                      }>
                      <a className="page-link" href="javascript:void(0);">
                        <i className="tf-icon bx bx-chevron-left"></i>
                      </a>
                    </li>

                    {pagination.map((p) => {
                      return (
                        <li
                          className={`page-item ${
                            currentPage === p ? "active" : ""
                          }`}
                          onClick={() => setPage(p)}>
                          <a className="page-link" href="javascript:void(0);">
                            {p}
                          </a>
                        </li>
                      );
                    })}

                    <li
                      className={`page-item next ${
                        lastPage === page ? "disabled" : ""
                      }`}
                      onClick={() =>
                        lastPage === page ? "" : setPage(currentPage + 1)
                      }>
                      <a className="page-link" href="javascript:void(0);">
                        <i className="tf-icon bx bx-chevron-right"></i>
                      </a>
                    </li>
                    <li
                      className="page-item last"
                      onClick={() => setPage(lastPage)}>
                      <a className="page-link" href="javascript:void(0);">
                        <i className="tf-icon bx bx-chevrons-right"></i>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </WebLayout>
  );
}

export default MyOrdersList;
